import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCollectionList {
  constructor(section) {
    this.el = section.el;

    initCarousel(this.el, {
      perPage: 2,
      perMove: 1,
      padding: {
        right: 45,
      },
      gap: '0.5rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.xs]: {
          perPage: 3,
        },
        [unitlessBreakpoints.sm]: {
          perPage: 4,
        },
        [unitlessBreakpoints.md]: {
          perPage: 6,
        },
        [unitlessBreakpoints.lg]: {
          perPage: 8,
        },
        [unitlessBreakpoints.xl]: {
          destroy: true,
        },
      },
    });
  }
}
